import React, { useState, useEffect, useCallback } from "react";
import { Button } from "react-bootstrap";
// Using Feather Icons for a clean look - assumes a link to feathericons is in index.html or globally available
// For simplicity in this answer, we'll use a standard text/emoji icon, but you can use an actual icon library

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Function to scroll the window to the top smoothly
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling effect
    });
  }, []);

  // Show or hide the button based on scroll position
  useEffect(() => {
    const toggleVisibility = () => {
      // Show button if page is scrolled down more than 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // We are using a fixed bottom-right position for the button
  const buttonStyle = {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 1040, // Below Navbar (1050), above most content
    opacity: isVisible ? 1 : 0,
    visibility: isVisible ? "visible" : "hidden",
    transition: "opacity 0.5s, visibility 0.5s",
    background: "linear-gradient(145deg, #15cfc0, #054e48)",
    border: "none",
    borderRadius: "50%",
    width: "55px",
    height: "55px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem",
    color: "#fff", // White arrow/text
  };

  return (
    <Button
      onClick={scrollToTop}
      style={buttonStyle}
      aria-label="Scroll to top"
      title="Scroll to Top"
    >
      <i className="bi bi-arrow-up" /> {/* Assuming Bootstrap Icons are available */}
    </Button>
  );
};

export default ScrollToTopButton;